{
    "general": {
        "custom_text": {
            "login": "Accedi ",
            "contact_us": "Contattaci",
            "show_more_collection": "mostra tutte le categorie",
            "hide_collection": "nascondi",
            "show_more_specification": "tutte le caratteristiche",
            "hide_specification": "nascondi",
            "product": "prodotto",
            "products": "prodotti",
            "new_product": "New",
            "login_page": {
                "remember_me": "Ricordami"
            },
            "signup_page": {
                "company": "Azienda",
                "signup_failed": "Richiesta di iscrizione fallita, riprova più tardi o contatta il Customer Service",
                "signup_success": "Richiesta di iscrizione inviata, verrai ricontattato per confermare i tuoi dati.",
                "account_area_disclaimer": "L'area riservata sarà presto disponibile.",
                "role_options": "Cliente, Agente, Conto terzi",
                "sector_options": "Rivendita, Produzione, Edilizia"
            },
            "specifications_product": {
                "famiglia": "Famiglia",
                "family": "Famiglia",
                "step": "Passo",
                "din": "DIN",
                "degree": "Grado",
                "uni": "UNI",
                "iso": "ISO",
                "class": "Classe",
                "finishing": "Finitura",
                "brand": "Marchio",
                "clothesColor": "Colore",
                "clothesMeasure": "Taglia",
                "color": "Colore",
                "hardness": "Durezza",
                "endurance": "Resistenza",
                "material": "Materiale",
                "cageMaterial": "Materiale Gabbia",
                "nutClass": "Classe Dado",
                "Antivibranti_Corpo": "Materiale corpo",
                "Antivibranti_TempEsercizio": "Temperatura di esercizio",
                "Antivibranti_Colore": "",
                "Antivibranti_Materiale": "",
                "Antivibranti_Note": "Note",
                "Antivibranti_Base": "Materiale base",
                "Antivibranti_Campana": "Materiale campana",
                "Antivibranti_Perno": "Materiale perno",
                "Antivibranti_Boccola": "Materiale boccola",
                "Antivibranti_Rondella": "Materiale rondella",
                "Antivibranti_DurezzaGomma": "Durezza gomma",
                "Antivibranti_Din": "Norma",
                "Antivibranti_Norma": "Norma",
                "Pressacavi_Corpo": "",
                "Pressacavi_Inserto": "Materiale inserto",
                "Pressacavi_Colore": "",
                "Pressacavi_Autoestinguenza": "Autoestinguenza",
                "Pressacavi_AnelloTenuta": "Materiale anello di tenuta",
                "Pressacavi_Oring": "",
                "Pressacavi_MaterialeGuarnizione": "Materiale guarnizione",
                "Pressacavi_Molla": "Materiale molla",
                "Pressacavi_TemperaturaEsercizio": "Temperatura di esercizio",
                "Pressacavi_Accessori": "",
                "Pressacavi_Note": "Note",
                "Pressacavi_AnelloTenutaInterno": "Materiale anello di tenuta interno",
                "Pressacavi_AnelloTenutaEsterno": "Materiale anello di tenuta esterno",
                "Pressacavi_GradoProtezione": "Grado di protezione",
                "Pressacavi_Membrana": "Materiale membrana",
                "Pressacavi_Guarnizione": "",
                "Pressacavi_PassaggioAria": "Passaggio aria",
                "Pressacavi_PassaggioAcqua": "Passaggio acqua",
                "Pressacavi_Impiego": "Impiego",
                "Pressacavi_Materiale": "Materiale",
                "Pressacavi_MaterialeCorpo": "Materiale corpo",
                "Pressacavi_MaterialeOring": "Materiale O-ring",
                "Pressacavi_TrattamentoSuperficiale": "",
                "Pressacavi_TrattamentoSuperficialeCorpo": "",
                "Pressacavi_TestStandard": "Test standard",
                "Pressacavi_UlCsaFile": "Ul/Csa-File",
                "Pressacavi_Certificazione": "Certificazione",
                "Fascette_Autoestinguenza": "Autoestinguenza",
                "Fascette_TempEsercizio": "Temperatura di esercizio",
                "Fascette_Adesivo": "Adesivo",
                "Fascette_Norma": "Norma",
                "Fascette_Certificazione": "Certificazione",
                "Fascette_MaterialeCorpo": "Materiale corpo",
                "Fascette_MaterialeGanascia": "Materiale ganascia",
                "Fascette_Materiale": "Materiale",
                "Piedini_Certificazione": "Certificazione",
                "Piedini_Colore": "",
                "Piedini_Note": "Note",
                "Piedini_Accessori": "Accessori",
                "Piedini_TrattamentoSuperficiale": "",
                "Piedini_MaterialePerno": "Materiale perno",
                "Piedini_TrattamentoSuperficialePerno": "",
                "Piedini_Materiale": "Materiale",
                "Piedini_MaterialeBase": "Materiale base",
                "Piedini_ColoreBase": "",
                "Piedini_TrattamentoSuperficialeBase": "",
                "Piedini_TrattamentoSuperficialeDado": "",
                "Piedini_MaterialeAntiscivolo": "Materiale antiscivolo",
                "Piedini_ColoreAntiscivolo": "",
                "Piedini_MaterialeDado": "Materiale dado",
                "FissaggioCavi_Norma": "Norma",
                "FissaggioCavi_Certificazione": "Certificazione",
                "FissaggioCavi_Autoestinguenza": "Autoestinguenza",
                "FissaggioCavi_Colore": "",
                "FissaggioCavi_Adesivo": "Adesivo",
                "FissaggioCavi_Note": "Note",
                "FissaggioCavi_Materiale": "Materiale",
                "Maniglie_CapacitaCarico": "Capacità di carico",
                "Maniglie_TempEsercizio": "Temperatura di esercizio",
                "Maniglie_Colore": "",
                "Maniglie_Note": "Note",
                "Maniglie_Dimensioni": "",
                "Maniglie_Finitura": "",
                "Maniglie_Materiale": "Materiale",
                "Maniglie_FInituraSuperficiale": "",
                "Maniglie_MaterialeImpugnatura": "Materiale impugnatura",
                "Maniglie_CoperturaImpugnatura": "",
                "Maniglie_TrattamentoSuperficialeImpugnatura": "",
                "Maniglie_FinituraSuperficialeImpugnatura": "",
                "Maniglie_MaterialeTappoCoperturaImpugnatura": "Materiale tappo di copertura impugnatura",
                "Maniglie_MaterialeBoccola": "Materiale boccola",
                "Maniglie_TrattamentoSuperficialeBoccola": "",
                "Maniglie_MaterialePerno": "Materiale perno",
                "Maniglie_TrattamentoSuperficialePerno": "",
                "Maniglie_MaterialeRondella": "Materiale rondella",
                "Maniglie_MaterialePressioneRondella": "Materiale rondella di pressione",
                "Maniglie_TrattamentoSuperficialeRondella": "",
                "Maniglie_MaterialePulsante": "Materiale pulsante",
                "Maniglie_MaterialeInserto": "Materiale inserto",
                "Maniglie_MaterialeSupporto": "Materiale supporti",
                "Maniglie_FinituraSuperficialeSupporto": "",
                "Maniglie_MaterialeTappoCoperturaSupporto": "Materiale tappo di copertura supporto",
                "Cerniere_MaterialeBaseSupportoSpina": "Materiale base, supporto, spina",
                "Cerniere_MaterialeBase": "",
                "Cerniere_Tipo": "",
                "Cerniere_Versione": "",
                "Cerniere_Colore": "",
                "Cerniere_Note": "Note",
                "Cerniere_TrattamentoSuperficialeBase": "",
                "Cerniere_MaterialeCorpo": "Materiale corpo",
                "Cerniere_FinituraSuperficialeSupporto": "",
                "Cerniere_MaterialeCoperchio": "",
                "Cerniere_MaterialeSfere": "Materiale sfera",
                "Cerniere_MaterialeRondella": "Materiale rondella",
                "Cerniere_MaterialeBoccolaPosizione": "Materiale boccola marcaposizione",
                "Cerniere_MaterialeRondellaAntifrizionamento": "Materiale rondella antifrizionamento",
                "Cerniere_MaterialeRondellaAntigrippaggio": "Materiale rondella antigrippaggio",
                "Cerniere_MaterialePerniFilettati": "",
                "Cerniere_TrattamentoSuperficialePerniFilettati": "",
                "Cerniere_MaterialeFlange": "Materiale flange",
                "Cerniere_FinituraSuperficialeFlange": "",
                "Cerniere_TrattamentoSuperficialeFlange": "",
                "Cerniere_MaterialeSpina": "Materiale spina",
                "Cerniere_FinituraSuperficialeSpina": "",
                "Cerniere_TrattamentoSuperficialeSpina": "",
                "Cerniere_MaterialeSeeger": "Materiale seeger",
                "Cerniere_TrattamentoSuperficialeSeegers": "",
                "Cerniere_MaterialePerno": "Materiale perni",
                "Cerniere_TrattamentoSuperficialePerno": "",
                "Cerniere_MaterialeVite": "Materiale vite",
                "Cerniere_MaterialeDado": "Materiale dado",
                "Cerniere_TrattamentoSuperficialeDado": "",
                "Cerniere_MaterialeMolla": "Materiale molla",
                "Cerniere_TrattamentoSuperficialeMolla": "",
                "Cerniere_MaterialeSpinaArresto": "Materiale spina d'arresto",
                "Cerniere_TrattamentoSuperficialeSpinaArresto": "",
                "Cerniere_MaterialePernoAllogiamento": "Materiale perno di alloggiamento",
                "Cerniere_TrattamentoSuperficialePernoAllogiamento": "",
                "Ruote_MaterialeAnello": "Materiale anello",
                "Ruote_MaterialeNucleo": "Materiale nucleo",
                "Ruote_MaterialeParafilo": "Materiale parafilo",
                "Ruote_TempEsercizio": "Temperatura di esercizio",
                "Ruote_Mozzo": "Mozzo",
                "Ruote_VelocitaLavoro": "Velocità di lavoro",
                "Ruote_Note": "Note",
                "Ruote_Impiego": "Impiego",
                "Ruote_Accessori": "Accessori",
                "Ruote_MaterialeRuota": "Materiale ruota",
                "Ruote_MaterialeSupporto": "Materiale supporto",
                "Ruote_Materiale": "",
                "Pomelli_ColoreImpugnatura": "",
                "Pomelli_ColoreTappo": "",
                "Pomelli_Colore": "",
                "Pomelli_Finitura": "",
                "Pomelli_Note": "Note",
                "Pomelli_MaterialeImpugnatura": "Materiale impugnatura",
                "Pomelli_Materiale": "",
                "Pomelli_FinituraImpugnatura": "",
                "Pomelli_MaterialePerno": "Materiale perno",
                "Pomelli_TrattamentoSuperficialePerno": "",
                "Pomelli_MaterialeBoccola": "Materiale boccola",
                "Pomelli_TrattamentoSuperficialeBoccola": "",
                "Pomelli_MaterialeSpina": "Materiale spina",
                "ChiusureLeva_Accessori": "",
                "ChiusureLeva_Note": "Note",
                "ChiusureLeva_TrattamentoSuperficiale": "",
                "ChiusureLeva_Materiale": "Materiale",
                "Sollevamento_MaterialeVite": "Materiale vite",
                "Sollevamento_MaterialeCorpo": "Materiale corpo",
                "Sollevamento_Certificazioni": "Certificazione",
                "Sollevamento_TempEsercizio": "Temperatura di esercizio",
                "Sollevamento_Orientabilita": "Orientabilità",
                "Sollevamento_CoefficenteSicurezza": "Coefficiente di sicurezza",
                "Sollevamento_Impiego": "Impiego",
                "Sollevamento_Note": "Note",
                "Sollevamento_Norma": "Norma",
                "Sollevamento_Test": "Test",
                "Sollevamento_Attenzione": "",
                "Sollevamento_Finitura": "",
                "Sollevamento_Materiale": "Materiale",
                "Magneti_PoloContrassegnato": "Polo contrassegnato",
                "Magneti_Grado": "Grado",
                "Magneti_TempEsercizio": "Temperatura di esercizio",
                "Magneti_Magnetizzazione": "Magnetizzazione",
                "Magneti_Note": "Note",
                "Magneti_TrattamentoSuperficiale": "",
                "Magneti_Materiale": "Materiale",
                "Magneti_MaterialeMagnete": "Materiale magnete",
                "Magneti_MaterialeRivestimento": "Materiale rivestimento",
                "Magneti_TrattamentoSuperficialeMagnete": "",
                "Magneti_MaterialeEspansore": "Materiale espansore",
                "Magneti_MaterialeCorpo": "Materiale corpo",
                "Magneti_TrattamentoSuperficialeCorpo": "",
                "ElemMeccanici_Accessori": "Accessori",
                "ElemMeccanici_Note": "Note",
                "ElemMeccanici_Impiego": "Impiego",
                "ElemMeccanici_Accoppiamento": "Accoppiamento",
                "ElemMeccanici_Norma": "Norma",
                "ElemMeccanici_TrattamentoSuperficiale": "",
                "ElemMeccanici_MaterialeCorpo": "Materiale corpo",
                "ElemMeccanici_TrattamentoSuperficialeCorpo": "",
                "ElemMeccanici_MaterialeBoccola": "Materiale boccola",
                "ElemMeccanici_Materiale": "Materiale",
                "ElemMeccanici_MaterialeMolla": "",
                "ElemMeccanici_MaterialeSfera": "Materiale sfera",
                "ElemMeccanici_MaterialeCorpoMaschio": "Materiale corpo maschio",
                "ElemMeccanici_MaterialeCorpoFemmina": "Materiale corpo femmina",
                "ElemMeccanici_MaterialeInternoMolla": "Materiale molla interna",
                "ElemMeccanici_MaterialeEsternoMolla": "Materiale molla esterna",
                "TappiPlastica_TempEsercizio": "Temperatura di esercizio",
                "TappiPlastica_Colore": "Colore",
                "TappiPlastica_Note": "Note",
                "TappiPlastica_MaterialeOring": "Materiale O-ring",
                "TappiPlastica_MaterialeCorpo": "Materiale corpo",
                "TappiPlastica_Materiale": "Materiale",
                "TappiPlastica_MaterialeDadi": "Materiale dadi",
                "ElemPosiz_Colore": "",
                "ElemPosiz_InsertoLongLok": "",
                "ElemPosiz_MarcaturaBloccaggio": "Marcatura di bloccaggio",
                "ElemPosiz_Accessori": "Accessori",
                "ElemPosiz_Note": "Note",
                "ElemPosiz_TrattamentoSuperficiale": "",
                "ElemPosiz_Materiale": "Materiale",
                "ElemPosiz_MaterialeCorpo": "Materiale corpo",
                "ElemPosiz_MaterialeImpugnatura": "Materiale impugnatura",
                "ElemPosiz_MaterialePerno": "Materiale perno",
                "ElemPosiz_MaterialePulsante": "Materiale pulsante",
                "ElemPosiz_MaterialeMolla": "Materiale molla",
                "ElemPosiz_MaterialePuntale": "Materiale puntale",
                "ElemPosiz_MaterialePernoBloccaggio": "Materiale perno di bloccaggio",
                "ElemPosiz_MaterialeAnello": "Materiale anello",
                "ElemPosiz_MaterialeManopola": "",
                "ElemPosiz_MaterialeSfera": "Materiale sfera",
                "ElemPosiz_MaterialeMolle": "Materiale molle",
                "ElemPosiz_MaterialeSfere": "Materiale sfere",
                "ElemPosiz_MaterialeOcchiello": "Materiale occhiello",
                "ElemPosiz_MaterialeCavoSpirale": "Materiale cavo a spirale",
                "ElemPosiz_MaterialeCavo": "",
                "ElemPosiz_MaterialeCavetto": "Materiale cavetto",
                "ElemPosiz_MaterialeMorsetto": "Materiale morsetto",
                "ElemPosiz_MaterialeCapocorda": "Materiale capocorda",
                "FissaggiPressione_TempEsercizio": "Temperatura di esercizio",
                "FissaggiPressione_Impiego": "Impiego",
                "FissaggiPressione_Autoestinguenza": "Autoestinguenza",
                "FisaggiPressione_Codice": "",
                "FissaggiPressione_Colore": "",
                "FissaggiPressione_Materiale": "Materiale",
                "Distanziatori_Adesivo": "Adesivo",
                "Distanziatori_Note": "Note",
                "Distanziatori_Autoestinguenza": "Autoestinguenza",
                "Distanziatori_TempEsercizio": "Temperatura di esercizio",
                "Distanziatori_Colore": "",
                "Distanziatori_Impiego": "Impiego",
                "Distanziatori_TrattamentoSuperficiale": "",
                "Distanziatori_Materiale": "Materiale",
                "Molle_Colore": "",
                "Molle_Note": "Note",
                "Molle_Materiale": "Materiale",
                "Molle_TrattamentoSuperficiale": "",
                "TerminaliElettrici_ProfiloCrimpatura": "Profilo di crimpatura",
                "TerminaliElettrici_Materiale": "Materiale",
                "TerminaliElettrici_Corpo": "Materiale corpo",
                "TerminaliElettrici_Morsetto": "Materiale morsetto",
                "TerminaliElettrici_Vite": "Materiale vite",
                "TerminaliElettrici_Isolamento": "Isolamento",
                "TerminaliElettrici_TensioneNominale": "Tensione nominale",
                "TerminaliElettrici_TempEsercizio": "Temperatura di esercizio",
                "TerminaliElettrici_Autoestinguenza": "Autoestinguenza",
                "TerminaliElettrici_Accessori": "Accessori",
                "TerminaliElettrici_Note": "Note",
                "TerminaliElettrici_Impiego": "Impiego",
                "TerminaliElettrici_UlCsaFile": "Ul/Csa-File",
                "materialScrewClass": "Materiale / Classe vite",
                "materialNutClass": "Materiale / Classe dado",
                "washerHardness": "Durezza rondella"
            }
        },
        "password_page": {
            "login_form_heading": "Accedi al negozio utilizzando la password:",
            "login_password_button": "Accedi utilizzando la password",
            "login_form_password_label": "Password",
            "login_form_password_placeholder": "La tua password",
            "login_form_error": "Password errata!",
            "login_form_submit": "Accedi",
            "admin_link_html": "Sei il proprietario del negozio? <a href=\"/admin\" class=\"link underlined-link\">Accedi qui</a>",
            "powered_by_shopify_html": "Questo negozio sarà ospitato su {{ shopify }}"
        },
        "social": {
            "alt_text": {
                "share_on_facebook": "Condividi su Facebook",
                "share_on_twitter": "Twitta su Twitter",
                "share_on_pinterest": "Aggiungi un pin su Pinterest"
            },
            "links": {
                "twitter": "Twitter",
                "facebook": "Facebook",
                "linkedin": "Linkedin",
                "pinterest": "Pinterest",
                "instagram": "Instagram",
                "tumblr": "Tumblr",
                "snapchat": "Snapchat",
                "youtube": "YouTube",
                "vimeo": "Vimeo",
                "tiktok": "TikTok"
            }
        },
        "continue_shopping": "Continua lo shopping",
        "pagination": {
            "label": "Impaginazione",
            "page": "Pagina {{ number }}",
            "next": "Pagina successiva",
            "previous": "Pagina precedente"
        },
        "br-pagination": {
            "label": "BR Impaginazione",
            "page": "Pagina {{ number }}",
            "next": "Pagina successiva",
            "previous": "Pagina precedente"
        },
        "search": {
            "search": "Cerca per nome, famiglia, ...",
            "search_code": "Cerca per codice articolo...",
            "search_generic": "Cerca...",
            "custom_search_title": "Ricerca",
            "reset": "Cancella termine ricerca",
            "art_code": "Codice articolo",
            "art_name": "Nome articolo"
        },
        "cart": {
            "view": "Visualizza carrello ({{ count }})",
            "item_added": "Articolo aggiunto al carrello",
            "view_empty_cart": "Visualizza carrello"
        },
        "share": {
            "copy_to_clipboard": "Copia link",
            "share_url": "Link",
            "success_message": "Link copiato negli appunti",
            "close": "Chiudi condivisione"
        },
        "slider": {
            "of": "su",
            "next_slide": "Scorri verso destra",
            "previous_slide": "Scorri verso sinistra",
            "name": "Cursore"
        }
    },
    "newsletter": {
        "label": "Indirizzo email",
        "success": "Grazie per l'iscrizione",
        "button_label": "Iscriviti"
    },
    "accessibility": {
        "skip_to_text": "Vai direttamente ai contenuti",
        "close": "Chiudi",
        "unit_price_separator": "per",
        "vendor": "Produttore:",
        "error": "Errore",
        "refresh_page": "Scegliendo una selezione si ottiene un aggiornamento completo della pagina.",
        "link_messages": {
            "new_window": "Si apre in una nuova finestra.",
            "external": "Apre un sito web esterno."
        },
        "loading": "Caricamento in corso...",
        "skip_to_product_info": "Passa alle informazioni sul prodotto",
        "total_reviews": "recensioni totali",
        "star_reviews_info": "{{ rating_value }} stelle su {{ rating_max }}",
        "collapsible_content_title": "Contenuto comprimibile",
        "complementary_products": "Prodotti complementari"
    },
    "blogs": {
        "article": {
            "blog": "Blog",
            "read_more_title": "Leggi di più: {{ title }}",
            "comments": {
                "one": "{{ count }} commento",
                "other": "{{ count }} commenti",
                "many": "{{ count }} commenti"
            },
            "moderated": "Si prega di notare che, prima di essere pubblicati, i commenti devono essere approvati.",
            "comment_form_title": "Lascia un commento",
            "name": "Nome",
            "email": "Indirizzo email",
            "message": "Commenta",
            "post": "Pubblica commento",
            "back_to_blog": "Torna al blog",
            "share": "Condividi questo articolo",
            "success": "Il tuo commento è stato pubblicato! Grazie!",
            "success_moderated": "Il tuo commento è stato pubblicato. Lo pubblicheremo fra poco, il nostro blog è soggetto a moderazione."
        }
    },
    "onboarding": {
        "product_title": "Esempio di titolo del prodotto",
        "collection_title": "Nome della collezione"
    },
    "products": {
        "product": {
            "add_to_cart": "Aggiungi al carrello",
            "description": "Descrizione",
            "certifications": "Certificazioni",
            "regulations": "Normative",
            "life_cycle": "Ciclo di Vita",
            "additional_tab": "Informazioni Addizionali",
            "on_sale": "In offerta",
            "quantity": {
                "label": "Quantità",
                "input_label": "Quantità per {{ product }}",
                "increase": "Aumenta quantità per {{ product }}",
                "decrease": "Diminuisci quantità per {{ product }}",
                "minimum_of": "Minimo di {{ quantity }}",
                "maximum_of": "Massimo di {{ quantity }}",
                "multiples_of": "Incrementi di {{ quantity }}",
                "in_cart_html": "<span class=\"quantity-cart\">{{ quantity }}</span> nel carrello",
                "note": "Visualizza regole sulla quantità"
            },
            "price": {
                "from_price_html": "Da {{ price }}",
                "regular_price": "Prezzo di listino",
                "sale_price": "Prezzo scontato",
                "unit_price": "Prezzo unitario"
            },
            "share": "Condividi questo prodotto",
            "sold_out": "Esaurito",
            "unavailable": "Non disponibile",
            "vendor": "Fornitore",
            "video_exit_message": "{{ title }} apre un video a schermo intero nella stessa finestra.",
            "xr_button": "Visualizza nel tuo spazio",
            "xr_button_label": "Visualizza nel tuo spazio, carica l'articolo nella finestra della realtà aumentata",
            "pickup_availability": {
                "view_store_info": "Visualizza i dettagli del negozio",
                "check_other_stores": "Verifica la disponibilità in altri negozi",
                "pick_up_available": "Ritiro disponibile",
                "pick_up_available_at_html": "Ritiro disponibile presso la sede <span class=\"color-foreground\">{{ location_name }}</span>",
                "pick_up_unavailable_at_html": "Ritiro attualmente non disponibile presso la sede <span class=\"color-foreground\">{{ location_name }}</span>",
                "unavailable": "Impossibile caricare la disponibilità di ritiro",
                "refresh": "Aggiorna"
            },
            "media": {
                "open_media": "Apri contenuti multimediali {{ index }} in finestra modale",
                "play_model": "Riproduci visualizzatore 3D",
                "play_video": "Riproduci video",
                "gallery_viewer": "Visualizzatore di galleria",
                "load_image": "Carica immagine {{ index }} in visualizzazione galleria",
                "load_model": "Carica modello 3D {{ index }} in visualizzazione galleria",
                "load_video": "Riproduci video {{ index }} in visualizzazione galleria",
                "image_available": "L'immagine {{ index }} è ora disponibile in visualizzazione galleria"
            },
            "view_full_details": "Visualizza dettagli completi",
            "include_taxes": "Imposte incluse.",
            "shipping_policy_html": "<a href=\"{{ link }}\">Spese di spedizione</a> calcolate al check-out.",
            "choose_options": "Scegli opzioni",
            "choose_product_options": "Scegli opzioni per {{ product_name }}",
            "value_unavailable": "{{ option_value }} - Non disponibile",
            "variant_sold_out_or_unavailable": "Variante esaurita o non disponibile",
            "inventory_in_stock": "Disponibile",
            "inventory_in_stock_show_count": "{{ quantity }} disponibile/i",
            "inventory_low_stock": "Scorte ridotte",
            "inventory_low_stock_show_count": "Scorte ridotte: ne restano {{ quantity }}",
            "inventory_out_of_stock": "Esaurito",
            "inventory_out_of_stock_continue_selling": "Disponibile",
            "sku": "SKU",
            "volume_pricing": {
                "title": "Prezzi basati sui volumi",
                "note": "Prezzi basati sui volumi disponibili",
                "minimum": "Più di {{ quantity }}",
                "price_at_each": "a {{ price }}/ciascuno",
                "price_range": "{{ minimum }} - {{ maximum }}"
            },
            "product_variants": "Varianti di prodotto",
            "all_variants": "Tutte le varianti",
            "tech_sheet_download": "Download scheda tecnica",
            "compliance_sheet_download": "Download scheda conformità",
            "login_to_see_prices": "Effettua il login per vedere i prezzi.",
            "login_to_quote_html": "<a href='/account/login'>Accedi</a> alla tua area riservata o registrati per richiedere un preventivo.",
            "want_to_be_customer": "Vorresti diventare nostro cliente?",
            "sign_up_to_buy_html": "<a href='/account/register'>Registrati</a>, riempi il carrello e richiedi un preventivo. Avvieremo il processo di affiliazione.",
            "want_to_quote": "Vuoi effettuare un ordine o richiedere un preventivo?",
            "in_the_cart": "All’interno del carrello potrai ordinare gli articoli selezionati o richiedere un preventivo.",
            "additional_infos": {
                "ElemPosiz_Colore": "Colore",
                "ElemPosiz_InsertoLongLok": "Inserto Long Lok"
            },
            "variants_title": "Varianti articolo",
            "variants_subtitle": "visualizza il carrello per ordinare o richiedere un nuovo preventivo"
        },
        "modal": {
            "label": "Galleria contenuti multimediali"
        },
        "facets": {
            "apply": "Applica",
            "clear": "Cancella",
            "clear_all": "Rimuovi tutto",
            "from": "Da",
            "filter_and_sort": "Filtra e ordina",
            "filter_by_label": "Filtra:",
            "filter_button": "Filtra",
            "filters_selected": {
                "one": "{{ count }} selezionata",
                "other": "{{ count }} selezionate",
                "many": "{{ count }} selezionate"
            },
            "max_price": "Il prezzo più alto è {{ price }}",
            "product_count": {
                "one": "{{ product_count }} su {{ count }} prodotto",
                "other": "{{ product_count }} su {{ count }} prodotti",
                "many": "{{ product_count }} su {{ count }} prodotti"
            },
            "product_count_simple": {
                "one": "{{ count }} prodotto",
                "other": "{{ count }} prodotti",
                "many": "{{ count }} prodotti"
            },
            "reset": "Ripristina",
            "sort_button": "Ordina",
            "sort_by_label": "Ordina per:",
            "to": "A",
            "clear_filter": "Rimuovi filtri",
            "filter_selected_accessibility": "{{ type }} ({{ count }} filtri selezionati)",
            "show_more": "Mostra di più",
            "show_less": "Mostra di meno",
            "filter_and_operator_subtitle": "Seleziona tutte"
        }
    },
    "templates": {
        "404": {
            "title": "Pagina non trovata",
            "subtext": "404"
        },
        "search": {
            "no_results": "Nessun risultato per \"{{ terms }}\". Controlla l'ortografia o usa una parola o una frase diversa.",
            "page": "Pagina",
            "results_with_count": {
                "one": "{{ count }} risultato",
                "other": "{{ count }} risultati",
                "many": "{{ count }} risultati"
            },
            "title": "Risultati della ricerca",
            "products": "Prodotti",
            "search_for": "Cerca \"{{ terms }}\"",
            "results_with_count_and_term": {
                "one": "{{ count }} risultato trovato per \"{{ terms }}\"",
                "other": "{{ count }} risultati trovati per \"{{ terms }}\"",
                "many": "{{ count }} risultati trovati per \"{{ terms }}\""
            },
            "results_pages_with_count": {
                "one": "{{ count }} pagina",
                "other": "{{ count }} pagine",
                "many": "{{ count }} pagine"
            },
            "results_products_with_count": {
                "one": "{{ count }} prodotto",
                "other": "{{ count }} prodotti",
                "many": "{{ count }} prodotti"
            },
            "suggestions": "Suggerimenti",
            "pages": "Pagine",
            "results_suggestions_with_count": {
                "one": "{{ count }} suggerimento",
                "other": "{{ count }} suggerimenti",
                "many": "{{ count }} suggerimenti"
            }
        },
        "cart": {
            "cart": "Carrello"
        },
        "contact": {
            "form": {
                "name": "Nome",
                "email": "Indirizzo email",
                "phone": "Numero di telefono",
                "comment": "Commenta",
                "send": "Invia",
                "post_success": "Grazie per averci contattato. Risponderemo il prima possibile.",
                "error_heading": "Correggi gli errori seguenti:",
                "title": "Modulo di contatto"
            }
        },
        "work_with_us": {
            "404": {
                "title": "TODO",
                "subtext": "TODO"
            },
            "form": {
                "first_name": "Nome",
                "last_name": "Cognome",
                "email": "Indirizzo email",
                "phone": "Numero di telefono",
                "presentation": "Lettera di presentazione",
                "terms": {
                    "name": "Termini e condizioni",
                    "first_text": "Per le finalità indicate in relazione all’",
                    "link_text": "informativa che mi avete fornito",
                    "last_text": ", esprimo il consenso al trattamento dei miei dati personali da parte della vostra Azienda."
                },
                "cv": {
                    "label": "Carica il tuo CV",
                    "select_file": "Seleziona file",
                    "no_files_uploaded": "Nessun file caricato",
                    "upload": "Carica",
                    "name": "CV file"
                },
                "send": "Invia candidatura",
                "comment": "TODO",
                "cart": {
                    "cart_title": "TODO",
                    "login_to_receive_quotation": "TODO",
                    "proceed_to_checkout": "TODO",
                    "minimum_order_total": "TODO",
                    "code": "TODO",
                    "details": "TODO",
                    "request_quotation": "TODO",
                    "request_quotation_text": "TODO",
                    "quote_all": "TODO",
                    "quote": "TODO",
                    "order_detail": "TODO",
                    "total_items": "TODO",
                    "subtotal": "TODO",
                    "quantity_discount": "TODO",
                    "total_no_vat": "TODO",
                    "vat": "TODO",
                    "total": "TODO",
                    "quote_request": "TODO",
                    "pieces": "TODO",
                    "pieces_short": "TODO",
                    "quote_request_text": "TODO",
                    "proceed": "TODO",
                    "csv_box_title": "TODO",
                    "csv_box_text": "TODO",
                    "csv_box_text_instructions": "TODO",
                    "csv_box_no_file": "TODO",
                    "csv_select_file": "TODO",
                    "csv_download": "TODO",
                    "csv_upload": "TODO",
                    "unit_price": "TODO",
                    "error_uploading_csv": "TODO",
                    "summary": {
                        "title": "TODO",
                        "subtitle": "TODO",
                        "order_summary": "TODO",
                        "addresses": "TODO",
                        "billing_address": "TODO",
                        "shipping_address": "TODO",
                        "additional_info": "TODO",
                        "your_reference": "TODO",
                        "input_reference": "TODO",
                        "note": "TODO",
                        "input_note": "TODO",
                        "order_items": "TODO",
                        "items_total": "TODO",
                        "discount": "TODO",
                        "order_total": "TODO",
                        "order_total_quote": "TODO",
                        "quote_summary": "TODO",
                        "input_note_quote": "TODO",
                        "quote_items": "TODO",
                        "disclaimer": "TODO",
                        "send": "TODO",
                        "error_send_order_quote": "TODO"
                    },
                    "thank_you": {
                        "thank_you_title": "TODO",
                        "for_more_info": "TODO",
                        "back_to_home": "TODO",
                        "order_title": "TODO",
                        "order_title_failed": "TODO",
                        "order_not_success": "TODO",
                        "order_success": "TODO",
                        "items_number": "TODO",
                        "quote_title": "TODO",
                        "quote_success": "TODO",
                        "quote_not_success": "TODO"
                    },
                    "send": "TODO",
                    "comment": "TODO"
                }
            }
        },
        "sections": {
            "announcements": {
                "previous_announcement": "TODO",
                "next_announcement": "TODO",
                "carousel": "TODO",
                "announcement": "TODO",
                "announcement_bar": "TODO"
            },
            "header": {
                "announcement": "TODO",
                "menu": "TODO"
            },
            "cart": {
                "title": "TODO",
                "caption": "TODO",
                "remove_title": "TODO",
                "estimated_total": "TODO",
                "new_estimated_total": "TODO",
                "note": "TODO",
                "checkout": "TODO",
                "empty": "TODO",
                "cart_error": "TODO",
                "cart_quantity_error_html": "TODO",
                "taxes_and_shipping_policy_at_checkout_html": "TODO",
                "taxes_included_but_shipping_at_checkout": "TODO",
                "taxes_included_and_shipping_policy_html": "TODO",
                "taxes_and_shipping_at_checkout": "TODO",
                "headings": {
                    "product": "TODO",
                    "price": "TODO",
                    "total": "TODO",
                    "quantity": "TODO",
                    "image": "TODO"
                },
                "update": "TODO",
                "login": {
                    "title": "TODO",
                    "paragraph_html": "TODO"
                }
            },
            "footer": {
                "payment": "TODO"
            },
            "featured_blog": {
                "view_all": "TODO",
                "onboarding_title": "TODO",
                "onboarding_content": "TODO"
            },
            "featured_collection": {
                "view_all": "TODO",
                "view_all_label": "TODO"
            },
            "collection_list": {
                "view_all": "TODO"
            },
            "collection_template": {
                "empty": "TODO",
                "title": "TODO",
                "use_fewer_filters_html": "TODO"
            },
            "video": {
                "load_video": "TODO"
            },
            "slideshow": {
                "load_slide": "TODO",
                "previous_slideshow": "TODO",
                "next_slideshow": "TODO",
                "pause_slideshow": "TODO",
                "play_slideshow": "TODO",
                "carousel": "TODO",
                "slide": "TODO"
            },
            "page": {
                "title": "TODO"
            },
            "quick_order_list": {
                "product_total": "TODO",
                "view_cart": "TODO",
                "each": "TODO",
                "product": "TODO",
                "variant": "TODO",
                "variant_total": "TODO",
                "product_variants": "TODO",
                "total_items": "TODO",
                "remove_all_items_confirmation": "TODO",
                "remove_all": "TODO",
                "cancel": "TODO"
            }
        },
        "localization": {
            "country_label": "TODO",
            "language_label": "TODO",
            "update_language": "TODO",
            "update_country": "TODO"
        },
        "customer": {
            "account": {
                "title": "TODO",
                "details": "TODO",
                "view_addresses": "TODO",
                "return": "TODO"
            },
            "account_fallback": "TODO",
            "activate_account": {
                "title": "TODO",
                "subtext": "TODO",
                "password": "TODO",
                "password_confirm": "TODO",
                "submit": "TODO",
                "cancel": "TODO"
            },
            "addresses": {
                "title": "TODO",
                "default": "TODO",
                "add_new": "TODO",
                "edit_address": "TODO",
                "first_name": "TODO",
                "last_name": "TODO",
                "company": "TODO",
                "address1": "TODO",
                "address2": "TODO",
                "city": "TODO",
                "country": "TODO",
                "province": "TODO",
                "zip": "TODO",
                "set_default": "TODO",
                "add": "TODO",
                "update": "TODO",
                "cancel": "TODO",
                "edit": "TODO",
                "delete": "TODO",
                "delete_confirm": "TODO"
            },
            "log_in": "TODO",
            "log_out": "TODO",
            "login_page": {
                "cancel": "TODO",
                "create_account": "TODO",
                "email": "TODO",
                "forgot_password": "TODO",
                "guest_continue": "TODO",
                "guest_title": "TODO",
                "password": "TODO",
                "title": "TODO",
                "sign_in": "TODO",
                "submit": "TODO",
                "send_edit_password_title": "TODO",
                "send_edit_password_subtitle": "TODO"
            },
            "order": {
                "title": "TODO",
                "date_html": "TODO",
                "cancelled_html": "TODO",
                "cancelled_reason": "TODO",
                "billing_address": "TODO",
                "payment_status": "TODO",
                "shipping_address": "TODO",
                "fulfillment_status": "TODO",
                "discount": "TODO",
                "shipping": "TODO",
                "tax": "TODO",
                "product": "TODO",
                "sku": "TODO",
                "price": "TODO",
                "quantity": "TODO",
                "total": "TODO",
                "total_refunded": "TODO",
                "fulfilled_at_html": "TODO",
                "track_shipment": "TODO",
                "tracking_url": "TODO",
                "tracking_company": "TODO",
                "tracking_number": "TODO",
                "subtotal": "TODO",
                "total_duties": "TODO"
            },
            "orders": {
                "title": "TODO",
                "order_number": "TODO",
                "order_number_link": "TODO",
                "date": "TODO",
                "payment_status": "TODO",
                "fulfillment_status": "TODO",
                "total": "TODO"
            },
            "recover_password": {
                "title": "TODO",
                "subtext": "TODO",
                "success": "TODO"
            },
            "register": {
                "title": "TODO",
                "subtitle": "TODO",
                "has_account": "TODO",
                "login": "TODO",
                "submit": "TODO",
                "create_account": {
                    "title": "TODO",
                    "email": "TODO",
                    "password": "TODO",
                    "password_confirm": "TODO"
                },
                "personal_info": {
                    "title": "TODO",
                    "first_name": "TODO",
                    "last_name": "TODO",
                    "role": "TODO"
                },
                "company": {
                    "title": "TODO",
                    "company_name": "TODO",
                    "vat_number": "TODO",
                    "business_sector": "TODO",
                    "employees_number": "TODO",
                    "address": "TODO",
                    "civic_address": "TODO",
                    "nation": "TODO",
                    "province": "TODO",
                    "postal_code": "TODO",
                    "city": "TODO"
                }
            },
            "reset_password": {
                "title": "TODO",
                "subtext": "TODO",
                "password": "TODO",
                "password_confirm": "TODO",
                "submit": "TODO"
            }
        },
        "gift_cards": {
            "issued": {
                "how_to_use_gift_card": "TODO",
                "title": "TODO",
                "subtext": "TODO",
                "gift_card_code": "TODO",
                "shop_link": "TODO",
                "add_to_apple_wallet": "TODO",
                "qr_image_alt": "TODO",
                "copy_code": "TODO",
                "expiration_date": "TODO",
                "copy_code_success": "TODO",
                "expired": "TODO"
            }
        },
        "recipient": {
            "form": {
                "checkbox": "TODO",
                "expanded": "TODO",
                "collapsed": "TODO",
                "email_label": "TODO",
                "email_label_optional_for_no_js_behavior": "TODO",
                "email": "TODO",
                "name_label": "TODO",
                "name": "TODO",
                "message_label": "TODO",
                "message": "TODO",
                "max_characters": "TODO",
                "send_on": "TODO",
                "send_on_label": "TODO"
            }
        },
        "select_customer": {
            "customer": "TODO",
            "select_customer": "TODO",
            "search_customer": "TODO",
            "code": "TODO",
            "name": "TODO",
            "customerGroup": "TODO"
        },
        "berardi": {
            "go_back": "TODO",
            "csv_importing": "TODO",
            "no_close_advice": "TODO",
            "error_csv_importing": "TODO",
            "success_full_csv_importing": "TODO",
            "success_partial_csv_importing": "TODO",
            "reorder_progress": "TODO",
            "error_reorder": "TODO",
            "success_full_reorder": "TODO",
            "success_partial_reorder": "TODO",
            "send_order_quote_progress": "TODO",
            "error_send_order_quote": "TODO",
            "account": {
                "menu": {
                    "general_infos": "TODO",
                    "company": "TODO",
                    "orders_history": "TODO",
                    "quotes_history": "TODO",
                    "invoices_history": "TODO",
                    "logout": "TODO"
                },
                "general_infos": {
                    "title": "TODO",
                    "account_infos": "TODO",
                    "user_name": "TODO",
                    "user_email": "TODO",
                    "user_role": "TODO",
                    "user_mobile": "TODO",
                    "change_password": "TODO",
                    "agency_infos": "TODO",
                    "customer_code": "TODO",
                    "company": "TODO",
                    "vat": "TODO",
                    "activity": "TODO",
                    "workers": "TODO",
                    "country": "TODO",
                    "province": "TODO",
                    "city": "TODO",
                    "zip": "TODO",
                    "address": "TODO"
                },
                "company": {
                    "title": "TODO",
                    "company": "TODO",
                    "customer_code": "TODO",
                    "name": "TODO",
                    "vat": "TODO",
                    "business": "TODO",
                    "workers": "TODO",
                    "country": "TODO",
                    "province": "TODO",
                    "city": "TODO",
                    "zip": "TODO",
                    "address": "TODO",
                    "operational_users": "TODO",
                    "table": {
                        "user_name": "TODO",
                        "email": "TODO"
                    },
                    "no_companies_found": "TODO"
                },
                "orders_history": {
                    "title": "TODO",
                    "label_select_company": "TODO",
                    "doc_number": "TODO",
                    "doc_number_placeholder": "TODO",
                    "from": "TODO",
                    "to": "TODO",
                    "search_order": "TODO",
                    "nothing_found": "TODO",
                    "error_reorder": "TODO",
                    "table": {
                        "order": "TODO",
                        "date": "TODO",
                        "total": "TODO",
                        "order_status": "TODO",
                        "reorder": "TODO",
                        "load_more": "TODO"
                    }
                },
                "quotes_history": {
                    "title": "TODO",
                    "label_select_company": "TODO",
                    "doc_number": "TODO",
                    "doc_number_placeholder": "TODO",
                    "from": "TODO",
                    "to": "TODO",
                    "search_quote": "TODO",
                    "nothing_found": "TODO",
                    "table": {
                        "quote": "TODO",
                        "date": "TODO",
                        "new_offer": "TODO",
                        "quote_status": "TODO",
                        "load_more": "TODO"
                    }
                },
                "invoices_history": {
                    "title": "TODO",
                    "label_select_company": "TODO",
                    "expired_invoices": "TODO",
                    "expiring_invoices": "TODO",
                    "payment_method": "TODO",
                    "billing_address": "TODO",
                    "nothing_found": "TODO",
                    "table": {
                        "invoice_number": "TODO",
                        "date": "TODO",
                        "expiring_date": "TODO",
                        "payment_method": "TODO",
                        "value": "TODO",
                        "invoice_status": "TODO",
                        "currency": "TODO",
                        "download": "TODO",
                        "load_more": "TODO",
                        "error_download": "TODO"
                    }
                },
                "order_detail": {
                    "title": "TODO",
                    "go_back": "TODO",
                    "download": "TODO",
                    "your_reference": "TODO",
                    "date_order": "TODO",
                    "weight": "TODO",
                    "payment": "TODO",
                    "return_terms": "TODO",
                    "billing_address": "TODO",
                    "shipping_address": "TODO",
                    "table": {
                        "art_code": "TODO",
                        "art_code_customer": "TODO",
                        "description": "TODO",
                        "measure_unit": "TODO",
                        "total_quantity": "TODO",
                        "unit_price": "TODO",
                        "discount_1": "TODO",
                        "discount_2": "TODO",
                        "discount_3": "TODO",
                        "increase": "TODO",
                        "net_unit_price": "TODO",
                        "net_total": "TODO",
                        "deliver_date": "TODO"
                    }
                },
                "quote_detail": {
                    "title": "TODO",
                    "go_back": "TODO",
                    "download": "TODO",
                    "your_reference": "TODO",
                    "date_quote": "TODO",
                    "weight": "TODO",
                    "payment": "TODO",
                    "return_terms": "TODO",
                    "billing_address": "TODO",
                    "shipping_address": "TODO",
                    "table": {
                        "art_code": "TODO",
                        "art_code_customer": "TODO",
                        "description": "TODO",
                        "measure_unit": "TODO",
                        "total_quantity": "TODO",
                        "unit_price": "TODO",
                        "discount_1": "TODO",
                        "discount_2": "TODO",
                        "discount_3": "TODO",
                        "increase": "TODO",
                        "net_unit_price": "TODO",
                        "net_total": "TODO",
                        "deliver_date": "TODO"
                    }
                },
                "document_status_list": {
                    "pending": "TODO",
                    "delivering": "TODO",
                    "delivered": "TODO",
                    "processed": "TODO",
                    "invoiced": "TODO",
                    "refused": "TODO",
                    "accepted": "TODO",
                    "on_customer_approve": "TODO",
                    "on_offer_progress": "TODO",
                    "canceled": "TODO",
                    "expired": "TODO",
                    "expiring": "TODO",
                    "paid": "TODO",
                    "active": "TODO",
                    "created": "TODO",
                    "approved": "TODO",
                    "cancelled": "TODO",
                    "confirmed": "TODO"
                },
                "totals_component": {
                    "text": "TODO",
                    "products_total": "TODO",
                    "discount": "TODO",
                    "net_total": "TODO",
                    "packaging": "TODO",
                    "shipment": "TODO",
                    "order_total": "TODO"
                }
            },
            "cart": {
                "cart_title": "TODO",
                "login_to_receive_quotation": "TODO",
                "proceed_to_checkout": "TODO",
                "minimum_order_total": "TODO",
                "code": "TODO",
                "details": "TODO",
                "request_quotation": "TODO",
                "request_quotation_text": "TODO",
                "quote_all": "TODO",
                "quote": "TODO",
                "order_detail": "TODO",
                "total_items": "TODO",
                "subtotal": "TODO",
                "quantity_discount": "TODO",
                "total_no_vat": "TODO",
                "vat": "TODO",
                "total": "TODO",
                "quote_request": "TODO",
                "pieces": "TODO",
                "pieces_short": "TODO",
                "quote_request_text": "TODO",
                "proceed": "TODO",
                "csv_box_title": "TODO",
                "csv_box_text": "TODO",
                "csv_box_text_instructions": "TODO",
                "csv_box_no_file": "TODO",
                "csv_select_file": "TODO",
                "csv_download": "TODO",
                "csv_upload": "TODO",
                "unit_price": "TODO",
                "error_uploading_csv": "TODO",
                "summary": {
                    "title": "TODO",
                    "subtitle": "TODO",
                    "order_summary": "TODO",
                    "addresses": "TODO",
                    "billing_address": "TODO",
                    "shipping_address": "TODO",
                    "additional_info": "TODO",
                    "your_reference": "TODO",
                    "input_reference": "TODO",
                    "note": "TODO",
                    "input_note": "TODO",
                    "order_items": "TODO",
                    "items_total": "TODO",
                    "discount": "TODO",
                    "order_total": "TODO",
                    "order_total_quote": "TODO",
                    "quote_summary": "TODO",
                    "input_note_quote": "TODO",
                    "quote_items": "TODO",
                    "disclaimer": "TODO",
                    "send": "TODO",
                    "error_send_order_quote": "TODO"
                },
                "thank_you": {
                    "thank_you_title": "TODO",
                    "for_more_info": "TODO",
                    "back_to_home": "TODO",
                    "order_title": "TODO",
                    "order_title_failed": "TODO",
                    "order_not_success": "TODO",
                    "order_success": "TODO",
                    "items_number": "TODO",
                    "quote_title": "TODO",
                    "quote_success": "TODO",
                    "quote_not_success": "TODO"
                }
            },
            "product": {
                "buttons": {
                    "tech_sheet_download": "TODO",
                    "compliance_sheet_download": "TODO"
                },
                "table_data": {
                    "code": "TODO",
                    "color": "TODO",
                    "brand": "TODO",
                    "material": "TODO"
                },
                "filters": {
                    "sku": "TODO"
                },
                "table": {
                    "art_code": "TODO",
                    "art_code_customer": "TODO",
                    "weight": "TODO",
                    "pieces_per_package": "TODO",
                    "unit_price": "TODO",
                    "total_price": "TODO",
                    "number_of_pieces": "TODO",
                    "availability": "TODO",
                    "associate": "TODO",
                    "login_to_see_price": "TODO",
                    "pieces": "TODO",
                    "details": "TODO",
                    "insufficient_qty": "TODO",
                    "not_available": "TODO",
                    "available": "TODO",
                    "load_more_variants": "TODO",
                    "added_product": "TODO",
                    "filter_label": "TODO",
                    "carico_max_dan": "TODO",
                    "diam_albero": "TODO",
                    "portata_in_kg": "TODO",
                    "dndeg_fil_x_pollice": "TODO"
                },
                "clothing_selector": {
                    "add_to_cart": "TODO",
                    "color": "TODO",
                    "size": "TODO",
                    "unit_price": "TODO",
                    "pieces_number": "TODO",
                    "total_price": "TODO",
                    "insufficient_qty": "TODO",
                    "not_available": "TODO",
                    "available": "TODO"
                }
            },
            "modals": {
                "general": {
                    "confirm": "TODO",
                    "cancel": "TODO"
                },
                "associate_id": {
                    "title": "TODO",
                    "paragraph": "TODO",
                    "customer_code": "TODO",
                    "placeholder": "TODO",
                    "warning_text": "TODO",
                    "explanation_confirm": "TODO",
                    "associate_button": "TODO"
                }
            },
            "search": {
                "search_code": "TODO",
                "cod_art": "TODO",
                "name_art": "TODO",
                "no_product_found": "TODO",
                "no_query": "TODO"
            },
            "general": {
                "login": "TODO",
                "sign_up": "TODO",
                "select": "TODO"
            }
        },
        "shopify": {
            "links": {
                "powered_by_shopify": "TODO"
            }
        }
    },
    "sections": {
        "header": {
            "announcement": "Annuncio",
            "menu": "Menu",
            "cart_count": {
                "one": "{{ count }} articolo",
                "other": "{{ count }} articoli",
                "many": "{{ count }} articoli"
            }
        },
        "cart": {
            "title": "Il tuo carrello",
            "caption": "Articoli nel carrello",
            "remove_title": "Rimuovi {{ title }}",
            "note": "Istruzioni speciali per l'ordine",
            "checkout": "Check-out",
            "empty": "Il tuo carrello è vuoto",
            "cart_error": "Si è verificato un errore durante l'aggiornamento del carrello. Riprova più tardi.",
            "cart_quantity_error_html": "Puoi aggiungere soltanto {{ quantity }} di questo articolo al tuo carrello.",
            "taxes_and_shipping_policy_at_checkout_html": "Imposte, sconti e <a href=\"{{ link }}\">spedizione</a> calcolati al check-out",
            "taxes_included_but_shipping_at_checkout": "Imposte incluse e spedizione e sconti calcolati al check-out",
            "taxes_included_and_shipping_policy_html": "Imposte incluse. <a href=\"{{ link }}\">Spedizione</a> e sconti calcolati al check-out.",
            "taxes_and_shipping_at_checkout": "Imposte, sconti e spedizione calcolati al check-out",
            "headings": {
                "product": "Prodotto",
                "price": "Prezzo",
                "total": "Totale",
                "quantity": "Quantità",
                "image": "Immagine del prodotto"
            },
            "update": "Aggiorna",
            "login": {
                "title": "Hai un account?",
                "paragraph_html": "<a href=\"{{ link }}\" class=\"link underlined-link\">Accedi</a> per un check-out più veloce."
            },
            "estimated_total": "Totale stimato",
            "new_estimated_total": "Nuovo totale stimato"
        },
        "footer": {
            "payment": "Metodi di pagamento"
        },
        "featured_blog": {
            "view_all": "Visualizza tutto",
            "onboarding_title": "Articolo del blog",
            "onboarding_content": "Offri ai clienti un riepilogo dell'articolo del blog"
        },
        "featured_collection": {
            "view_all": "Visualizza tutto",
            "view_all_label": "Visualizza tutti i prodotti della collezione {{ collection_name }}"
        },
        "collection_list": {
            "view_all": "Visualizza tutto"
        },
        "collection_template": {
            "title": "Collezione",
            "empty": "Nessun prodotto trovato",
            "use_fewer_filters_html": "Utilizza meno filtri o <a class=\"{{ class }}\" href=\"{{ link }}\">rimuovi tutto</a>"
        },
        "video": {
            "load_video": "Carica il video: {{ description }}"
        },
        "slideshow": {
            "load_slide": "Carica slide",
            "previous_slideshow": "Slide precedente",
            "next_slideshow": "Slide successiva",
            "pause_slideshow": "Metti in pausa presentazione",
            "play_slideshow": "Avvia presentazione",
            "carousel": "Carousel",
            "slide": "Scorrimento"
        },
        "page": {
            "title": "Titolo pagina"
        },
        "announcements": {
            "previous_announcement": "Annuncio precedente",
            "next_announcement": "Annuncio successivo",
            "carousel": "Carousel",
            "announcement": "Annuncio",
            "announcement_bar": "Barra degli annunci"
        },
        "quick_order_list": {
            "product_total": "Subtotale prodotto",
            "view_cart": "Visualizza carrello",
            "each": "{{ money }}/ciascuno",
            "product": "Prodotto",
            "variant": "Variante",
            "variant_total": "Totale varianti",
            "items_added": {
                "one": "{{ quantity }} articolo aggiunto",
                "other": "{{ quantity }} articoli aggiunti",
                "many": "{{ quantity }} articoli aggiunti"
            },
            "items_removed": {
                "one": "{{ quantity }} articolo rimosso",
                "other": "{{ quantity }} articoli rimossi",
                "many": "{{ quantity }} articoli rimossi"
            },
            "product_variants": "Varianti di prodotto",
            "total_items": "Articoli totali",
            "remove_all_items_confirmation": "Rimuovere tutti i {{ quantity }} articoli dal tuo carrello?",
            "remove_all": "Rimuovi tutto",
            "cancel": "Annulla"
        }
    },
    "localization": {
        "country_label": "Paese/Area geografica",
        "language_label": "Lingua",
        "update_language": "Aggiorna lingua",
        "update_country": "Aggiorna paese/area geografica"
    },
    "customer": {
        "account": {
            "title": "Account",
            "details": "Dettagli account",
            "view_addresses": "Visualizza indirizzi",
            "return": "Ritorna ai dettagli dell'account"
        },
        "account_fallback": "Account",
        "activate_account": {
            "title": "Attiva l'account",
            "subtext": "Crea una password per attivare il tuo account.",
            "password": "Password",
            "password_confirm": "Conferma password",
            "submit": "Attiva l'account",
            "cancel": "Rifiuta invito"
        },
        "addresses": {
            "title": "Indirizzi",
            "default": "Predefinito",
            "add_new": "Aggiungi un nuovo indirizzo",
            "edit_address": "Modifica indirizzo",
            "first_name": "Nome",
            "last_name": "Cognome",
            "company": "Azienda",
            "address1": "Indirizzo - campo 1",
            "address2": "Indirizzo - campo 2",
            "city": "Città",
            "country": "Paese/Area geografica",
            "province": "Provincia",
            "zip": "CAP",
            "phone": "Numero di telefono",
            "set_default": "Imposta come indirizzo predefinito",
            "add": "Aggiungi indirizzo",
            "update": "Aggiorna indirizzo",
            "cancel": "Annulla",
            "edit": "Modifica",
            "delete": "Elimina",
            "delete_confirm": "Desideri davvero eliminare questo indirizzo?"
        },
        "log_in": "Accedi",
        "log_out": "Esci",
        "login_page": {
            "cancel": "Annulla",
            "create_account": "Crea account",
            "email": "Indirizzo email",
            "forgot_password": "Hai dimenticato la password?",
            "guest_continue": "Continua",
            "guest_title": "Continua senza registrarti",
            "password": "Password",
            "title": "Accedi",
            "sign_in": "Accedi",
            "submit": "Invia",
            "send_edit_password_title": "Invia richiesta modifica",
            "send_edit_password_subtitle": "Ti invieremo tramite email il link per modificare la tua password"
        },
        "order": {
            "title": "Ordine {{ name }}",
            "date_html": "Effettuato il {{ date }}",
            "cancelled_html": "Ordine annullato il giorno {{ date }}",
            "cancelled_reason": "Motivo: {{ reason }}",
            "billing_address": "Indirizzo di fatturazione",
            "payment_status": "Stato del pagamento",
            "shipping_address": "Indirizzo di spedizione",
            "fulfillment_status": "Stato di evasione",
            "discount": "Sconto",
            "shipping": "Spedizione",
            "tax": "Imposta",
            "product": "Prodotto",
            "sku": "SKU",
            "price": "Prezzo",
            "quantity": "Quantità",
            "total": "Totale",
            "fulfilled_at_html": "Evaso il {{ date }}",
            "track_shipment": "Monitora la spedizione",
            "tracking_url": "Link di monitoraggio",
            "tracking_company": "Corriere",
            "tracking_number": "Numero di tracking",
            "subtotal": "Subtotale",
            "total_duties": "Dazi",
            "total_refunded": "Rimborsato"
        },
        "orders": {
            "title": "Cronologia ordini",
            "order_number": "Ordine",
            "order_number_link": "Ordine numero {{ number }}",
            "date": "Data",
            "payment_status": "Stato del pagamento",
            "fulfillment_status": "Stato di evasione",
            "total": "Totale",
            "none": "Non hai ancora effettuato ordini."
        },
        "recover_password": {
            "title": "Reimposta la password",
            "subtext": "Riceverai un'email per reimpostare la tua password",
            "success": "Ti abbiamo inviato un'email con un link per aggiornare la password."
        },
        "register": {
            "title": "Registrati per diventare cliente",
            "subtitle": "Registrati per accedere alla tua area riservata. Potrai avere accesso al listino prezzi dei nostri prodotti, effettuare gli ordini e richiedere preventivi per il tuo punto vendita.",
            "has_account": "Hai già un account?",
            "login": "Accedi",
            "submit": "Crea",
            "create_account": {
                "title": "Creazione account",
                "email": "Indirizzo email",
                "password": "Password",
                "password_confirm": "Conferma password"
            },
            "personal_info": {
                "title": "Info personali",
                "first_name": "Nome",
                "last_name": "Cognome",
                "role": "Ruolo",
                "phone": "Cellulare"
            },
            "company": {
                "title": "Azienda",
                "company_name": "Ragione sociale",
                "vat_number": "P. IVA",
                "business_sector": "Settore attività",
                "employees_number": "Numero dipendenti",
                "phone": "Telefono",
                "address": "Indirizzo",
                "civic_address": "Civico",
                "nation": "Nazione",
                "province": "Provincia",
                "postal_code": "Cap",
                "city": "Città"
            }
        },
        "reset_password": {
            "title": "Reimposta la password dell'account",
            "subtext": "Inserisci una nuova password",
            "password": "Password",
            "password_confirm": "Conferma password",
            "submit": "Reimposta password"
        }
    },
    "gift_cards": {
        "issued": {
            "title": "Ecco il saldo del tuo buono regalo dal valore di {{ value }} per {{ shop }}!",
            "subtext": "Il tuo buono regalo",
            "gift_card_code": "Codice del buono regalo",
            "shop_link": "Visita il negozio online",
            "add_to_apple_wallet": "Aggiungi a Apple Wallet",
            "qr_image_alt": "Codice QR — scansiona per riscattare il buono regalo",
            "copy_code": "Copia codice del buono regalo",
            "expired": "Scaduto",
            "copy_code_success": "Codice copiato correttamente",
            "how_to_use_gift_card": "Utilizza il codice del buono regalo online o il codice QR in negozio",
            "expiration_date": "Scade il giorno {{ expires_on }}"
        }
    },
    "recipient": {
        "form": {
            "checkbox": "Voglio inviarlo come regalo",
            "email_label": "Email destinatario",
            "email": "email",
            "name_label": "Nome destinatario (facoltativo)",
            "name": "Nome",
            "message_label": "Messaggio (facoltativo)",
            "message": "Messaggio",
            "max_characters": "Massimo {{ max_chars }} caratteri",
            "email_label_optional_for_no_js_behavior": "Email destinatario (facoltativa)",
            "send_on": "AAAA-MM-GG",
            "send_on_label": "Spedisci il giorno (opzionale)",
            "expanded": "Modulo destinatario del buono regalo espanso",
            "collapsed": "Modulo destinatario del buono regalo compresso"
        }
    },
    "select_customer": {
        "customer": "Cliente",
        "select_customer": "Seleziona Cliente o Gruppo clienti",
        "search_customer": "Cerca per codice, nome cliente, gruppo...",
        "code": "Codice cliente",
        "name": "Nome cliente",
        "customerGroup": "Gruppo cliente"
    },
    "shopify": {
        "page_titles": {
            "search": "Cerca"
        },
        "checkout": {
            "shop_policies": {
                "refund_policy": "Informativa sui rimborsi#"
            }
        },
        "links": {
            "powered_by_shopify": "Berardi Bullonerie s.r.l. Tutti i diritti riservati. | Via San Carlo, 1. Loc. Poggio Piccolo, 40023, Castel Guelfo (Bologna) - Italia | C.F. 03512270376 - P. Iva: 00628991200 | Iscr. Reg. Imprese di Bologna n. 03512270376 - REA BOLOGNA N.297741 | Cap. Soc. € 81.264,69 i.v."
        }
    },
    "berardi": {
        "go_back": "Torna indietro",
        "csv_importing": "Sto importando il CSV selezionato.",
        "no_close_advice": "Non chiudere o ricaricare questa pagina.",
        "error_csv_importing": "Si è verificato un errore durante il caricamento del CSV.",
        "success_full_csv_importing": "Import del CSV avvenuto con successo.",
        "success_partial_csv_importing": "L'import del CSV è avvenuto con successo, ma sono presenti errori.",
        "reorder_progress": "Sto aggiungendo al carrello i prodotti dell'ordine selezionato.",
        "error_reorder": "Si è verificato un errore durante l'aggiunta al carrello.",
        "success_full_reorder": "Aggiunta al carrello avvenuta con successo.",
        "success_partial_reorder": "L'aggiunta al carrello è avvenuta con successo, ma sono presenti errori.",
        "send_order_quote_progress": "Sto creando l'ordine e/o il preventivo.",
        "error_send_order_quote": "Si è verificato un errore durante la creazione dell'ordine e/o il preventivo.",
        "account": {
            "menu": {
                "general_infos": "Info generali",
                "company": "Società",
                "orders_history": "Storico ordini",
                "quotes_history": "Storico preventivi",
                "invoices_history": "Storico fatture",
                "logout": "Logout"
            },
            "general_infos": {
                "title": "Informazioni generali",
                "account_infos": "Informazioni account",
                "user_name": "Nome utente",
                "user_email": "E-mail",
                "user_role": "Ruolo",
                "user_mobile": "Cellulare",
                "change_password": "Cambia password",
                "agency_infos": "Informazioni azienda",
                "customer_code": "Cod. cliente",
                "company": "Ragione sociale",
                "vat": "P.IVA",
                "activity": "Settore attività",
                "workers": "Dipendenti",
                "phone": "Telefono",
                "country": "Nazione",
                "province": "Provincia",
                "city": "Città",
                "zip": "Cap",
                "address": "Indirizzo"
            },
            "company": {
                "title": "Società",
                "company": "Ragione sociale",
                "customer_code": "Cod. cliente",
                "name": "Ragione sociale",
                "vat": "P.IVA",
                "business": "Settore attività",
                "workers": "Dipendenti",
                "phone": "Telefono",
                "country": "Nazione",
                "province": "Provincia",
                "city": "Città",
                "zip": "Cap",
                "address": "Indirizzo",
                "operational_users": "Utenti abilitati",
                "table": {
                    "user_name": "Nome utente",
                    "email": "Email",
                    "phone": "Cellulare"
                },
                "no_companies_found": "Nessun dato trovato"
            },
            "orders_history": {
                "title": "Storico ordini",
                "label_select_company": "Visualizza ordini della società:",
                "doc_number": "Numero documento",
                "doc_number_placeholder": "es. 0046100300300",
                "from": "Da",
                "to": "a",
                "search_order": "Cerca ordine",
                "nothing_found": "Nessun ordine trovato",
                "error_reorder": "Si è verificato un errore durante l'operazione.",
                "table": {
                    "order": "Ordine",
                    "date": "Data",
                    "total": "Totale",
                    "order_status": "Stato ordine",
                    "reorder": "riordina",
                    "load_more": "Carica altri ordini"
                }
            },
            "quotes_history": {
                "title": "Storico preventivi",
                "label_select_company": "Visualizza preventivi della società:",
                "doc_number": "Numero documento",
                "doc_number_placeholder": "es. 0046100300300",
                "from": "Da",
                "to": "a",
                "search_quote": "Cerca preventivo",
                "nothing_found": "Nessun preventivo trovato",
                "table": {
                    "quote": "Preventivo",
                    "date": "Data",
                    "new_offer": "Nuova offerta",
                    "quote_status": "Stato preventivo",
                    "load_more": "Carica altri preventivi"
                }
            },
            "invoices_history": {
                "title": "Storico fatture",
                "label_select_company": "Visualizza situazione finanziaria della società:",
                "expired_invoices": "Fatture scadute",
                "expiring_invoices": "Fatture in scadenza",
                "payment_method": "Tipo pagamento",
                "billing_address": "Indirizzo di fatturazione",
                "nothing_found": "Nessuna fattura trovata",
                "table": {
                    "invoice_number": "Numero fattura",
                    "date": "Data di emissione",
                    "expiring_date": "Data di scadenza",
                    "payment_method": "Metodo di pagamento",
                    "value": "Importo da pagare",
                    "invoice_status": "Stato fattura",
                    "currency": "Valuta",
                    "download": "Scarica",
                    "load_more": "Carica altre fatture",
                    "error_download": "Errore durante lo scaricamento della fattura"
                }
            },
            "order_detail": {
                "title": "Ordine",
                "go_back": "Indietro",
                "download": "Download",
                "your_reference": "Vostro riferimento",
                "date_order": "Data ordine",
                "weight": "Peso in kg",
                "payment": "Pagamento",
                "return_terms": "Termini di resa",
                "billing_address": "Indirizzo di fatturazione",
                "shipping_address": "Indirizzo di spedizione",
                "table": {
                    "art_code": "Cod. Articolo",
                    "art_code_customer": "Cod. Art. cliente",
                    "description": "Descrizione",
                    "measure_unit": "U. m.",
                    "total_quantity": "Qtà tot",
                    "unit_price": "Prezzo un.",
                    "discount_1": "Sc. 1",
                    "discount_2": "Sc. 2",
                    "discount_3": "Sc. 3",
                    "increase": "Mag. incr.",
                    "net_unit_price": "Prezzo un. netto",
                    "net_total": "Importo netto",
                    "deliver_date": "Data consegna"
                }
            },
            "quote_detail": {
                "title": "Preventivo",
                "go_back": "Indietro",
                "download": "Download",
                "your_reference": "Vostro riferimento",
                "date_quote": "Data preventivo",
                "weight": "Peso in kg",
                "payment": "Pagamento",
                "return_terms": "Termini di resa",
                "billing_address": "Indirizzo di fatturazione",
                "shipping_address": "Indirizzo di spedizione",
                "table": {
                    "art_code": "Cod. Articolo",
                    "art_code_customer": "Cod. Art. cliente",
                    "description": "Descrizione",
                    "measure_unit": "U. m.",
                    "total_quantity": "Qtà tot",
                    "unit_price": "Prezzo un.",
                    "discount_1": "Sc. 1",
                    "discount_2": "Sc. 2",
                    "discount_3": "Sc. 3",
                    "increase": "Mag. incr.",
                    "net_unit_price": "Prezzo un. netto",
                    "net_total": "Importo netto",
                    "deliver_date": "Data consegna"
                }
            },
            "document_status_list": {
                "pending": "in lavorazione",
                "delivering": "in consegna",
                "delivered": "consegnato",
                "processed": "evaso",
                "invoiced": "fatturato",
                "refused": "rifiutato",
                "accepted": "accettato",
                "on_customer_approve": "in approvazione cliente",
                "on_offer_progress": "in fase di offerta",
                "canceled": "cancellato",
                "expired": "scaduta",
                "expiring": "in scadenza",
                "paid": "pagata",
                "active": "attivo",
                "created": "creato",
                "approved": "approvato",
                "cancelled": "cancellato",
                "confirmed": "confermato"
            },
            "totals_component": {
                "text": "Le condizioni generali di fornitura disponibili su www.gberardi.com si applicano a tutti i contratti di vendita da parte di BERARDI BULLONERIE s.r.l. Condizioni contrattuali difformi, anche ove contenute in condizioni generali o particolari di acquisto predisposte dal cliente stesso, non trovano applicazione e non vincolano BERARDI BULLONERIE s.r.l se non accettate espressamente e per iscritto da quest’ultima",
                "products_total": "Numero articoli",
                "discount": "Sconto",
                "net_total": "Totale netto",
                "packaging": "Spese accessorie",
                "shipment": "Trasporto",
                "order_total": "Totale ordine"
            }
        },
        "cart": {
            "cart_title": "Il mio carrello",
            "login_to_receive_quotation": "Accedi o registrati per richiedere un preventivo.",
            "proceed_to_checkout": "Procedi per visualizzare il Riepilogo della richiesta.",
            "minimum_order_total": "L'importo minimo consentito per un ordine è",
            "code": "Cod. art.",
            "details": "dettagli",
            "request_quotation": "Richiedi preventivo",
            "request_quotation_text": "Invia una richiesta di preventivo con prodotti inseriti a carrello. Sarai contattato dal nostro servizio clienti con un’offerta a te dedicata.",
            "quote_all": "Richiedi preventivo per tutti gli articoli",
            "quote": "preventivo",
            "order_detail": "Dettaglio ordine",
            "total_items": "Numero articoli",
            "subtotal": "Subtotale",
            "quantity_discount": "Sconto quantità",
            "total_no_vat": "Totale IVA esclusa",
            "vat": "IVA",
            "total": "Totale IVA inclusa",
            "quote_request": "Richiesta preventivo",
            "pieces": "Pezzi",
            "pieces_short": "pz",
            "quote_request_text": "Il subtotale calcolato è provvisorio, la richiesta di preventivo è finalizzata al ricalcolo del prezzo nel caso in cui la numerosità richiesta sia alta.",
            "proceed": "Procedi",
            "csv_box_title": "Vuoi riempire il tuo carrello in maniera massiva?",
            "csv_box_text": "Carica il tuo file .csv con i codici prodotto e la quantità desiderate.",
            "csv_box_text_instructions": "Inserisci i tuoi codici articolo, se presenti nel nostro sistema, nella colonna CUSTOMER_CODE",
            "csv_box_no_file": "Nessun file .csv caricato",
            "csv_select_file": "Seleziona file",
            "csv_download": "Download template",
            "csv_upload": "Carica",
            "unit_price": "Prezzo unitario",
            "error_uploading_csv": "Errore durante il caricamento del CSV",
            "summary": {
                "title": "Riepilogo",
                "subtitle": "Invia la richiesta al nostro servizio clienti. Potrai sempre controllare lo stato della richiesta all’interno della tua area personale.",
                "order_summary": "Riepilogo ordine",
                "addresses": "Indirizzi",
                "billing_address": "Indirizzo di fatturazione",
                "shipping_address": "Indirizzo di spedizione",
                "additional_info": "Informazioni aggiuntive",
                "your_reference": "Vostro riferimento",
                "input_reference": "Inserisci riferimento",
                "note": "Nota",
                "input_note": "Aggiungi una nota",
                "order_items": "Articoli ordine",
                "items_total": "Tot. merce",
                "discount": "Sconto",
                "order_total": "Totale ordine",
                "order_total_quote": "richiesta preventivo",
                "quote_summary": "Riepilogo preventivo",
                "input_note_quote": "Aggiungi una nota al preventivo",
                "quote_items": "Articoli preventivo",
                "disclaimer": "Le condizioni generali di fornitura disponibili su www.gberardi.com si applicano a tutti i contratti di vendita da parte di BERARDI BULLONERIE s.r.l. Condizioni contrattuali difformi, anche ove contenute in condizioni generali o particolari di acquisto predisposte dal cliente stesso, non trovano applicazione e non vincolano BERARDI BULLONERIE s.r.l se non accettate espressamente e per iscritto da quest’ultima",
                "send": "Invia",
                "error_send_order_quote": "Si è verificato un errore durante l'invio dell'ordine"
            },
            "thank_you": {
                "thank_you_title": "Grazie per averci scelto!",
                "for_more_info": "Abbiamo ricevuto con successo la tua richiesta. Potrai monitorare l’avanzamento della richiesta all’interno della tua area personale.",
                "back_to_home": "Torna alla home",
                "order_title": "Ordine",
                "order_title_failed": "Ordine inviato",
                "order_not_success": "Il tuo ordine richiede la verifica da parte di un nostro operatore. Non appena sarà terminata la verifica troverai il tuo ordine nella sezione Storico Ordini",
                "order_success": "L’ordine è stato inviato correttamente. Presto potrai monitorare lo stato all’interno della tua area personale.",
                "items_number": "Numero articoli",
                "quote_title": "Richiesta di preventivo inviata",
                "quote_success": "Nelle prossime ore riceverai la quotazione da un nostro operatore",
                "quote_not_success": "Il tuo preventivo richiede una verifica da parte nostra, non appena sarà terminata riceverai la quotazione da un nostro operatore"
            }
        },
        "product": {
            "buttons": {
                "tech_sheet_download": "Download scheda tecnica",
                "compliance_sheet_download": "Download scheda conformità"
            },
            "table_data": {
                "code": "Codice",
                "color": "Colore",
                "brand": "Brand",
                "material": "Material"
            },
            "filters": {
                "sku": "Cod. art."
            },
            "table": {
                "art_code": "Cod. Art",
                "art_code_customer": "Cod. Art. Cliente",
                "weight": "Peso",
                "pieces_per_package": "Pz per conf.",
                "unit_price": "Prezzo unitario",
                "total_price": "Prezzo totale",
                "number_of_pieces": "Numero pezzi",
                "availability": "Disponibilità",
                "associate": "Associa",
                "login_to_see_price": "Accedi per visualizzare il prezzo del prodotto",
                "pieces": "Pezzi",
                "details": "dettagli",
                "insufficient_qty": "Parz. disponibile",
                "not_available": "Non disponibile",
                "available": "Disponibile",
                "load_more_variants": "Carica altre varianti",
                "added_product": "Prodotto aggiunto al carrello: ",
                "filter_label": "Filtra per",
                "carico_max_dan": "Carico max (daN)",
                "diam_albero": "Ø albero",
                "portata_in_kg": "Portata (kg)",
                "dndeg_fil_x_pollice": "d/n° fil. x pollice"
            },
            "clothing_selector": {
                "color": "Colore",
                "size": "Taglia",
                "unit_price": "Prezzo unitario",
                "pieces_number": "Numero pezzi",
                "total_price": "Prezzo totale",
                "add_to_cart": "Aggiungi al carrello",
                "insufficient_qty": "Parz. disponibile",
                "not_available": "Non disponibile",
                "available": "Disponibile"
            }
        },
        "modals": {
            "general": {
                "confirm": "Conferma",
                "cancel": "Annulla"
            },
            "associate_id": {
                "title": "Codice articolo cliente",
                "paragraph": "Inserisci il tuo codice cliente da associare all’articolo.",
                "customer_code": "Cod. Art. Cliente",
                "placeholder": "Inserisci codice cliente",
                "warning_text": "Attenzione! Campo modificabile una sola volta!",
                "explanation_confirm": "Controlla che il codice cliente inserito sia corretto e conferma l’associazione. In seguito non potrai più modificarlo in autonomia. In futuro per la modifica del codice sarà necessario contattare l’assistenza clienti di Berardi Bullonerie s.r.l.",
                "associate_button": "Associa"
            }
        },
        "search": {
            "search_code": "Cerca per codice...",
            "cod_art": "Codice articolo",
            "name_art": "Nome articolo",
            "no_product_found": "Nessun prodotto trovato",
            "no_query": "Scrivi nella barra di ricerca e premi INVIO per ricevere dei risultati"
        },
        "general": {
            "login": "Accedi",
            "sign_up": "Registrati",
            "select": "Seleziona"
        }
    }
}
